import React, { Component } from "react";
import { Link } from "react-router-dom";
import {
  Grid,
  Table,
  TableHeaderRow
} from "@devexpress/dx-react-grid-bootstrap4";
import GridUtils from "../../../Utilities/GridUtils";
import { get } from '../../../services/Transport';
import { signOut } from '../carbonActions';
import { connect } from 'react-redux';


const columns = [
  { name: "http_status_code", title: "HTTP STATUS" },
  { name: "http_method", title: "HTTP METHOD & RESOURCE" },
  { name: "host", title: "REMOTE HOST" },
  { name: "created_at", title: "ACCESS DATE" },
  { name: "status", title: "REQUEST STATUS" }
];


class AppActivity extends Component {

  state = {
    rows: []
  }

  

  componentDidMount(){
    const app_id = this.props.match.params.app_id;
    // alert(app_id);
    get(`/apps/logs?app_id=${app_id}`)
    .then(res =>{
      const rows = res.data.data;
      // alert(JSON.stringify(rows[0]))
      rows.map(el =>{
        if(el.http_status_code >= 200 && el.http_status_code < 300){
          el.status = "Success"
        }else if(el.http_status_code >= 400){
          el.status = "Failed"
        }
      })
      rows.map(el => {
        el.http_method += "  " + el.resource.slice(25)
      })
      this.setState({ rows });
    })
    .catch(err =>{
      if(err.response){
        if(err.response.status === 403){
          this.props.signOut();
        }
      }
    })
  }

  render() {
    const { rows } = this.state;
    return (
      <>
        <div className="alert alert-light alert-elevate" role="alert">
          <div className="alert-icon">
            <i className="flaticon-warning kt-font-brand"></i>
          </div>
          <div className="alert-text">
            Here, you'll see all activities and logs generated by this App.
          </div>
        </div>
        {/*Begin::Row*/}
        <div className="row">
          <div className="col-xl-12 col-lg-12 order-lg-3 order-xl-1">
            {/*begin:: Widgets/Best Sellers*/}
            <div class="kt-portlet">
              <div class="kt-portlet__head">
                <div class="kt-portlet__head-label">
                  <Link className="btn btn-light" to="/v1/developers/apps">
                    <i className="ti-back-left"></i>
                  </Link>{" "}
                  &nbsp;
                  <h3 class="kt-portlet__head-title">App Activity Log</h3>
                </div>
              </div>
              <div class="kt-portlet__body">
                <Grid rows={rows} columns={columns}>
                  <Table />
                  <TableHeaderRow />
                </Grid>

                <div class="kt-separator kt-separator--space-lg kt-separator--border-dashed"></div>
              </div>
            </div>
          </div>
        </div>

        {/*End::Row*/}

      </>
    );
  }
}

export default connect(null,{ signOut })(AppActivity);
